import $ from 'cash-dom';

class VendorsListCarousel {
	constructor(carouselId, splideOptions = {}) {
		this._$vendorsListSplide = $('#' + carouselId);
		this._splide = null;

		const splideDefaultOptions = {
			type: 'slide',
			rewind: true,
			gap: '20px',
			arrows: false,
			breakpoints: {
				5120: {
					destroy: true,
				},
				1023: {
					destroy: false,
				},
			},
			fixedWidth: '75%',
		};
		this._splideOptions = {...splideDefaultOptions, ...(splideOptions || {})};
	}

	init() {
		if (!this._$vendorsListSplide.length) {
			return;
		}

		$(document).on('filters-change', () => {
			this._cloneVendorsAndMountCarousel();
		});

		this._cloneVendorsAndMountCarousel();
	}

	_cloneVendorsAndMountCarousel() {
		if (this._splide !== null) {
			this._splide.destroy(true);
		}

		const $splideList = this._$vendorsListSplide.find('.splide__list');
		$splideList.html(null);

		$('.vendors-list .ppc-single-vendor').not('.hidden').each((i, vendor) => {
			const $vendorClone = $(vendor).clone();

			$vendorClone.addClass('splide__slide');
			Alooma.applyAloomaTrackingForLink($vendorClone.get(0));
			$vendorClone.find('a, [href]').each((i, link) => Alooma.applyAloomaTrackingForLink(link));

			$splideList.append($vendorClone);
		});

		this._splide = new Splide(this._$vendorsListSplide.get(0), this._splideOptions);

		this._splide.on('mounted', () => {
			this._handleBlur($splideList, 0);
		});

		this._splide.mount();

		this._splide.on('move', (newIndex, prevIndex, destIndex) => {
			this._handleBlur($splideList, newIndex);
		});

		$(document).trigger('vendors-list-carousel-mounted');
	}

	_handleBlur($splideList, newIndex) {
		$splideList.find('.splide__slide').removeClass('blured');

		const {Elements} = this._splide.Components;
		const nextElement = Elements.slides[newIndex + 1];
		const prevElement = Elements.slides[newIndex - 1];

		if (nextElement) {
			$(nextElement).addClass('blured');
		} else if (prevElement) {
			$(prevElement).addClass('blured');
		}
	}
}

export default VendorsListCarousel;